import React from 'react';
import { ShieldCheck, Truck, Map, DollarSign, HeadphonesIcon, Clock } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    icon: ShieldCheck,
    title: 'Fully Insured',
    desc: 'Comprehensive cargo insurance included with every heavy haul quote for total peace of mind.'
  }, {
    icon: Truck,
    title: 'Experienced Haulers',
    desc: 'Our drivers specialize exclusively in heavy equipment transport, handling machinery of all sizes and weights.'
  }, {
    icon: Map,
    title: 'Nationwide Coverage',
    desc: 'Door-to-door heavy haulers operating across all 50 states, including job site to job site services.'
  }, {
    icon: DollarSign,
    title: 'Transparent Pricing',
    desc: 'No hidden fees, no bait-and-switch. The equipment shipping quote you get is the price you pay.'
  }, {
    icon: HeadphonesIcon,
    title: '24/7 Support',
    desc: 'Dedicated logistics coordinators available around the clock to track your machinery transport.'
  }, {
    icon: Clock,
    title: 'On-Time Delivery',
    desc: 'We respect your project schedule. Reliable transit times and consistent communication throughout the move.'
  }];
  return <section className="py-20 bg-white" data-id="element-327">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-328">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-329">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-330">
            Why Choose LynJones Logistics?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-331">
            Because we set the standard. Experience quick, reliable, and
            hassle-free heavy load transport services from the industry's most
            accountable experts.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-332">
          {/* Reasons Grid */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-333">
            {reasons.map((reason, index) => <div key={index} className="p-6 rounded-2xl border border-slate-100 bg-slate-50 hover:shadow-lg transition-shadow duration-300" data-id="element-334">
                <div className="w-12 h-12 bg-brand-navy/5 rounded-xl flex items-center justify-center mb-4" data-id="element-335">
                  <reason.icon className="w-6 h-6 text-brand-red" data-id="element-336" />
                </div>
                <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-337">
                  {reason.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-338">
                  {reason.desc}
                </p>
              </div>)}
          </div>

          {/* Credibility Photo */}
          <div className="lg:col-span-4 h-full" data-id="element-339">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-full min-h-[400px] lg:min-h-full" data-id="element-340">
              <img src="https://images.unsplash.com/photo-1587293852726-70cdb56c2866?q=80&w=800&auto=format&fit=crop" alt="Excavator securely strapped on a transport trailer" className="absolute inset-0 w-full h-full object-cover" data-id="element-341" />
              <div className="absolute inset-0 bg-brand-navy/20" data-id="element-342"></div>
              <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-sm border border-white/20" data-id="element-343">
                <p className="text-brand-navy font-bold text-sm flex items-center gap-2" data-id="element-344">
                  <ShieldCheck className="w-4 h-4 text-brand-red" data-id="element-345" />
                  Fully Insured Transport
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}